module.exports = __webpack_public_path__ + "static/media/beep.60145df2.mp3";